<template>
  <LayoutsDefault>
    <slot />
  </LayoutsDefault>
</template>
